export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/minmax.worker.d1315657.worker.js");
}
